import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'src/shared/components/ui/accordion';

interface CustomAccordionProps {
    title: React.ReactNode;
    content: React.ReactNode;
}

const CustomAccordion = ({ title, content }: CustomAccordionProps) => {
    return (
        <Accordion type='single' collapsible>
            <AccordionItem value='item-1'>
                <AccordionTrigger className='bg-[#F6F6F6] min-h-[10px]'>{title}</AccordionTrigger>
                <AccordionContent>{content}</AccordionContent>
            </AccordionItem>
        </Accordion>
    );
};

export default CustomAccordion;
